import React, { useState, useEffect, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "../services/api";
import Papa from "papaparse";
import { HiDocumentReport } from "react-icons/hi";
import { TbReportMoney } from "react-icons/tb";
import { MdOutlineCancel } from "react-icons/md";
import {
  FaSearch,
  FaUndo,
  FaPrint,
  FaEdit,
  FaTrashAlt,
  FaSyncAlt,
  FaPlus,
} from "react-icons/fa";
import "./TransactionsPage.css";

const TransactionsPage = () => {
  const { id: businessId } = useParams();
  const navigate = useNavigate();


  const [transactions, setTransactions] = useState([]);
  const [categories, setCategories] = useState([]);
  const [accounts, setAccounts] = useState([]);

  const [selectedAccount, setSelectedAccount] = useState("all");
  const [selectedCategory, setSelectedCategory] = useState("");
  const [searchKeyword, setSearchKeyword] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const [selectedTransactions, setSelectedTransactions] = useState([]);
  const [showEditPopup, setShowEditPopup] = useState(false);
  const [editCategory, setEditCategory] = useState("");

  const [offset, setOffset] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const [resetFilters, setResetFilters] = useState(false);

  //const [categorySummary, setCategorySummary] = useState([]);

  const [newCategory, setNewCategory] = useState("");
  const [categoryType, setCategoryType] = useState("Expense");
  const [showCategoryPopup, setShowCategoryPopup] = useState(false);

  const [selectAll, setSelectAll] = useState(false);

  const [amount, setAmount] = useState("");

  const [showNotePopup, setShowNotePopup] = useState(false);
  const [currentNote, setCurrentNote] = useState("");
  const [currentTxnId, setCurrentTxnId] = useState(null);

  const [searchSubmitted, setSearchSubmitted] = useState(false);

  const [lastSearchedCategory, setLastSearchedCategory] = useState("");

  const [csvPreviewData, setCsvPreviewData] = useState([]);
const [showCsvPreview, setShowCsvPreview] = useState(false);

const [selectedUploadAccount, setSelectedUploadAccount] = useState("");

const [showUploadInstruction, setShowUploadInstruction] = useState(false);

const [showFundingWarning, setShowFundingWarning] = useState(false);


const [isCsvSubmitting, setIsCsvSubmitting] = useState(false);
const [isSyncing, setIsSyncing] = useState(false);



  





  


  const [showAddPopup, setShowAddPopup] = useState(false);
    const [newTxn, setNewTxn] = useState({
      date: "",
      name: "",
      category: "",
      category_type: "",
      notes: "",
      account_id: ""
    });






  const tableRef = useRef();


  const formatCategory = (cat) =>
    cat ? cat.toLowerCase().replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase()) : "";

  const fetchTransactions = async (reset = false) => {
    try {
      const res = await api.get(`/plaid/transactions/${businessId}`, {
        params: {
          offset: reset ? 0 : offset,
          account_id: selectedAccount !== "all" ? selectedAccount : undefined,
        },
      });

      if (res.data.length < 50) setHasMore(false);
      else setHasMore(true);

      if (reset) {
        setTransactions(res.data);
        setOffset(50);
      } else {
        setTransactions((prev) => [...prev, ...res.data]);
        setOffset((prev) => prev + 50);
      }
    } catch (err) {
      console.error("Error fetching transactions:", err);
    }
  };

  const fetchAccounts = async () => {
    try {
      const res = await api.get(`/plaid/by-accounts/${businessId}`);
      setAccounts(res.data || []);
    } catch (err) {
      console.error("Error fetching accounts:", err);
    }
  };

  const fetchCategories = async () => {
    try {
      const res = await api.get("/categories", {
        params: { business_id: businessId },
      });
      setCategories(res.data || []);
    } catch (err) {
      console.error("Error fetching categories:", err);
    }
  };

  useEffect(() => {
    fetchCategories();
    fetchAccounts();
    fetchTransactions(true);
    const checkFunding = async () => {
  try {
    const res = await api.get(`/billing/funding-check/${businessId}`);
    setShowFundingWarning(res.data.showFundingWarning);
  } catch (err) {
    console.error("❌ Failed to check funding warning:", err);
    setShowFundingWarning(true); // Fail safe
  }
};

checkFunding();
    // eslint-disable-next-line
  }, [businessId]);

  


     useEffect(() => {
     if (showEditPopup && selectedTransactions.length === 0) {
       setShowEditPopup(false);
     }
   }, [selectedTransactions, showEditPopup]);



   useEffect(() => {
    if (resetFilters) {
      fetchTransactions(true);
      setResetFilters(false);
    }
    // eslint-disable-next-line
  }, [resetFilters]);
  

  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedTransactions([]);
    } else {
      const allIds = transactions.map((txn) => txn.id);
      setSelectedTransactions(allIds);
    }
    setSelectAll(!selectAll);
  };


  useEffect(() => {
    const allIds = transactions.map((txn) => txn.id);
    const allSelected = allIds.every((id) => selectedTransactions.includes(id));
    setSelectAll(allSelected);
  }, [transactions, selectedTransactions]);
  
  
  

  const goToBreakdown = () => {
    const query = new URLSearchParams();
  
    if (selectedAccount !== "all") {
      const selected = accounts.find((a) => a.account_id === selectedAccount);
      if (selected) {
        query.append("account_id", selectedAccount);
        query.append("mask", selected.mask); 
        query.append("subtype", selected.subtype);// 👈 Add the mask
      }
    }
  
    navigate(`/dashboard/business/${businessId}/breakdown?${query.toString()}`);
  };
  
const normalizeAmountValue = (value) => {
  if (value === null || value === undefined) return "";

  let str = String(value).trim();

  if (!str) return "";

  // Handle parentheses as negative values: (123.45) => -123.45
  const isNegativeByParens = /^\(.*\)$/.test(str);
  if (isNegativeByParens) {
    str = str.slice(1, -1);
  }

  // Remove dollar signs, commas, and spaces
  str = str.replace(/\$/g, "").replace(/,/g, "").trim();

  // Remove any stray plus sign
  str = str.replace(/^\+/, "");

  const num = parseFloat(str);
  if (isNaN(num)) return "";

  return isNegativeByParens ? String(-num) : String(num);
};


const handleCSVUpload = (e) => {
  const file = e.target.files[0];
  if (!file) return;

  const normalizeKey = (key) => {
    switch (String(key).trim().toLowerCase()) {
      case "description":
      case "name":
        return "name";
      case "amount":
        return "amount";
      case "date":
        return "date";
      case "account_id":
      case "account id":
      case "account":
        return "account_id";
      default:
        return String(key).trim().toLowerCase();
    }
  };

  Papa.parse(file, {
    header: true,
    skipEmptyLines: true,
    transformHeader: (header) => normalizeKey(header),
    complete: (results) => {
      if (results.errors && results.errors.length > 0) {
        console.warn("CSV parse warnings:", results.errors);
      }

      const data = (results.data || [])
        .map((row) => {
          const cleanedRow = {};
          Object.keys(row || {}).forEach((key) => {
            cleanedRow[key] =
              row[key] !== null && row[key] !== undefined
                ? String(row[key]).trim()
                : "";
          });

          return {
            date: cleanedRow.date || "",
            name: cleanedRow.name || "",
            amount: normalizeAmountValue(cleanedRow.amount),
            account_id: cleanedRow.account_id || "",
          };
        })
        .filter((row) => {
          return row.date || row.name || row.amount || row.account_id;
        });

      if (!data.length) {
        alert("No valid rows found in the CSV.");
        return;
      }

      console.log("Parsed CSV preview:", data);
      setCsvPreviewData(data);
      setShowCsvPreview(true);

      if (window.csvInputRef) {
        window.csvInputRef.value = "";
      }
    },
    error: (error) => {
      console.error("CSV parse error:", error);
      alert("Failed to parse CSV file.");
    },
  });
};

//   const handleCSVUpload = (e) => {
//   const file = e.target.files[0];
//   if (!file) return;

//   const reader = new FileReader();
//   reader.onload = (event) => {
//     const lines = event.target.result.split("\n").filter(Boolean);

//     const normalizeKey = (key) => {
//       switch (key.trim().toLowerCase()) {
//         case "description":
//         case "name":
//           return "name";
//         case "amount":
//           return "amount";
//         case "date":
//           return "date";
//         case "account_id":
//         case "account id":
//         case "account":
//           return "account_id";
//         default:
//           return key.toLowerCase();
//       }
//     };

//     const headers = lines[0].split(",").map((h) => normalizeKey(h));

//     const data = lines.slice(1).map((line) => {
//       let values = [];

//       if (line.includes('"')) {
//         // 🔥 CASE: Description is quoted and has commas
//         const firstQuote = line.indexOf('"');
//         const lastQuote = line.lastIndexOf('"');

//         const beforeDesc = line.substring(0, firstQuote).split(",").map(v => v.trim());
//         const description = line.substring(firstQuote + 1, lastQuote);
//         const afterDesc = line.substring(lastQuote + 1).split(",").map(v => v.trim()).filter(Boolean);

//         values = [beforeDesc[0], description, ...afterDesc];
//       } else {
//         // Normal line
//         values = line.split(",").map((v) => v.trim());
//       }

//       return headers.reduce((obj, header, i) => {
//         obj[header] = values[i] || "";
//         return obj;
//       }, {});
//     }).filter((row) => {
//       return Object.values(row).some(val => val && val.trim() !== "");
//     });

//     setCsvPreviewData(data);
//     setShowCsvPreview(true);

//     if (window.csvInputRef) {
//       window.csvInputRef.value = "";
//     }
//   };
//   reader.readAsText(file);
// };


  
  

  const handleSearchSubmit = async () => {
    try {
      const params = {
        business_id: businessId,
      };

      if (selectedAccount !== "all") {
        params.account_id = selectedAccount;
      }
      if (selectedCategory) {
        params.category = selectedCategory;
      }
      if (searchKeyword) {
        params.keyword = searchKeyword;
      }
      if (startDate && endDate) {
        params.start_date = startDate;
        params.end_date = endDate;
      }
      if (amount) {
        params.amount = amount;
      }
      

      const res = await api.get(`/plaid/transactions/${businessId}/search`, { params });
      setTransactions(res.data);
      setHasMore(false);
      setSearchSubmitted(true);
      setLastSearchedCategory(selectedCategory);
    } catch (err) {
      console.error("Search failed", err);
    }
  };


  const handleAddTransaction = async () => {
    // Basic validation
    const { date, name, category, category_type, amount } = newTxn;
    if (!date || !name || !category || !category_type || !amount) {
      return alert("Please fill out all fields.");
    }
  
    try {
      // Adjust amount based on category type
      const adjustedAmount =
        category_type === "Income"
          ? -Math.abs(parseFloat(amount))
          : Math.abs(parseFloat(amount));
  
      await api.post("/plaid/manual-transaction", {
        ...newTxn,
        amount: adjustedAmount,
        business_id: businessId,
      });
  
      alert("Transaction added successfully.");
      setShowAddPopup(false);
      setNewTxn({
        date: "",
        name: "",
        category: "",
        category_type: "",
        amount: "",
        notes: "",
      });
      fetchTransactions(true); // refresh list
    } catch (err) {
      console.error("Failed to add transaction:", err);
      alert("Failed to add transaction.");
    }
  };
  
  

  

  const handleSelectTransaction = (id) => {
    setSelectedTransactions((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );
  };


  const handleEditSelected = async () => {
    try {
      const payload = {
        transactionIds: selectedTransactions,
        category: editCategory,
        business_id: businessId, 
      };
  
      // 🆕 Only include the keyword if:
      // 1️⃣ There is a search keyword, and
      // 2️⃣ The "Select All" checkbox is checked
      if (searchKeyword.trim() !== "" && selectAll) {
        payload.keyword = searchKeyword.trim();
      }
  
      await api.put("/transactions/update-categories", payload);
      alert("Updated!");
      setShowEditPopup(false);
      setSelectedTransactions([]);
      setEditCategory("");
  
      handleSearchSubmit();
    } catch (err) {
      console.error("Failed to update categories", err);
    }
  };
  
  

  

  const handleDeleteSelected = async () => {
    const confirmed = window.confirm("Are you sure you want to delete the selected transactions?");
    if (!confirmed) return;

    try {
      await api.delete("/transactions/delete", {
        data: { transactionIds: selectedTransactions },
      });
      alert("Deleted!");
      setSelectedTransactions([]);
      handleSearchSubmit();
    } catch (err) {
      console.error("Error deleting", err);
      alert("Error deleting transactions.");
    }
  };

  const handleResetFilters = () => {
    setSelectedAccount("all");
    setSelectedCategory("");
    setSearchKeyword("");
    setStartDate("");
    setEndDate("");
    setAmount("");
    setResetFilters(true);
    setSearchSubmitted(false);
    
  };

  // const filtersApplied =
  // selectedCategory !== "" ||
  // searchKeyword !== "";

  const totalAmount = transactions.reduce((sum, txn) => {
    const amt = parseFloat(txn.amount);
    return !isNaN(amt) ? sum + amt : sum;
  }, 0);


  const handleRefreshTransactions = async () => {
    if (isSyncing) return;

    setIsSyncing(true);
    try {
      const res = await api.post(`/plaid/sync`);
      alert(res.data);
      fetchTransactions(true); // reload view
    } catch (err) {
      console.error("Refresh failed:", err);
      alert("Failed to refresh transactions.");
    } finally {
    setIsSyncing(false);
  }
  };

  const handlePrint = () => {
    const printContent = tableRef.current.innerHTML;
    const printWindow = window.open("", "", "width=800,height=600");
    printWindow.document.write(`
      <html>
        <head>
          <title>Print Transactions</title>
          <style>
            body { font-family: Arial, sans-serif; padding: 20px; }
            table { width: 100%; border-collapse: collapse; margin-top: 20px; }
            th, td { border: 1px solid #ccc; padding: 8px; text-align: left; }
            tfoot td { font-weight: bold; }
          </style>
        </head>
        <body>
          <h2>Transactions Report</h2>
          ${printContent}
        </body>
      </html>
    `);
    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
    printWindow.close();
  };
  


  const handleCategorySubmit = async () => {
    if (!newCategory || !categoryType) return alert("Please fill all fields.");
    try {
      await api.post("/plaid-categories", {
        name: newCategory,
        category_type: categoryType,
        business_id: businessId,
      });
      alert("Category added.");
      fetchCategories();
      setNewCategory("");
      setCategoryType("Expense");
      setShowCategoryPopup(false);
    } catch (err) {
      console.error("Failed to add category:", err);
      alert("Failed to add category");
    }
  };
  


  


  
   


  const goToProfitLoss = () => {
    if (!startDate || !endDate) {
      alert("Please select both start and end date.");
      return;
    }
  
    const query = new URLSearchParams({
      start_date: startDate,
      end_date: endDate,
    });
  
    if (selectedAccount !== "all") {
      query.append("account_id", selectedAccount);
    }
  
    navigate(`/dashboard/business/${businessId}/profit-loss?${query.toString()}`);
  };
  
  
  
  


  

  return (
    <div className="transactions-page-container">
      <h1 className="pw-page-title">Transactions</h1>

      <table className="filter-table">
  <tbody>
    <tr>
      <td>
        <select
          value={selectedAccount}
          onChange={(e) => setSelectedAccount(e.target.value)}
          className="transaction-select"
        >
          <option value="all">All Accounts</option>
          {accounts.map((acct) => (
            <option key={acct.account_id} value={acct.account_id}>
              {acct.subtype} ••••{acct.mask}
            </option>
          ))}
        </select>
      </td>
      <td>
      <div className="date-div-trans">
      <label>From Date</label>
        <input
          type="date"
          value={startDate}
          onChange={(e) => setStartDate(e.target.value)}
        />
        </div>
      </td>
      <td>
      <div className="date-div-trans">
      <label>To Date</label>
        <input
          type="date"
          value={endDate}
          onChange={(e) => setEndDate(e.target.value)}
        />
        </div>
      </td>
      <td>
        <button
          className="profit-btn"
          onClick={goToProfitLoss}
          disabled={!startDate || !endDate}
          title="Start and End Dates Required"
        >
          <TbReportMoney />
        </button>
      </td>
      <td>
        <button
          className="icon-btn breakdown-btn"
          onClick={goToBreakdown}
          title="Breakdown"
        >
          <HiDocumentReport />
        </button>
      </td>
    </tr>
    <tr>
      <td>
        <select
          value={selectedCategory}
          className="transaction-select"
          onChange={(e) => {
            const value = e.target.value;
            if (value === "__add_new__") {
              setShowCategoryPopup(true);
              return;
            }
            setSelectedCategory(value);
          }}
        >
          <option value="">All Categories</option>
          {categories.map((cat) => (
            <option key={cat.id} value={cat.name}>
              {formatCategory(cat.name)}
            </option>
          ))}
          <option value="__add_new__">+ Add Category +</option>
        </select>
      </td>
      <td>
        <input
          type="text"
          placeholder="Keyword"
          value={searchKeyword}
          onChange={(e) => setSearchKeyword(e.target.value)}
        />
      </td>
      <td>
        <input
          type="number"
          placeholder="Amount"
          value={amount}
          onChange={(e) => setAmount(e.target.value)}
          step="0.01"
        />
      </td>
      <td>
        <button
          className="icon-btn search-btn"
          onClick={handleSearchSubmit}
          title="Search"
        >
          <FaSearch />
        </button>
      </td>
      <td>
        <button
          className="icon-btn cancel-btn"
          onClick={handleResetFilters}
          title="Reset Filters"
        >
          <FaUndo />
        </button>
      </td>
    </tr>
  </tbody>
</table>






      <div className="transactions-view-section">

      {window.innerWidth <= 768 && (
          <div className="mobile-select-all">
          
            <input
              type="checkbox"
              checked={selectAll}
              onChange={handleSelectAll}
            />
            
          </div>
        )}


        
        <button
          className="icon-btn add-btn"
          onClick={() => setShowAddPopup(true)}
          title="Add Transaction"
        >
          <FaPlus />
        </button>

        <button
          className="icon-btn edit-btn"
          onClick={() => setShowEditPopup(true)}
          disabled={selectedTransactions.length === 0}
          title="Edit Category"
        >
          <FaEdit />
        </button>
        
        <button
          className="icon-btn delete-btn"
          onClick={handleDeleteSelected}
          disabled={selectedTransactions.length === 0}
          title="Delete Selected"
        >
          <FaTrashAlt />
        </button>

        <button
          className="icon-btn print-btn"
          onClick={handlePrint}
          title="Print"
        >
          <FaPrint />
        </button>

        {/* <button
          className="icon-btn refresh-btn"
          onClick={handleRefreshTransactions}
          title="Refresh Transactions"
        >
          <FaSyncAlt />
        </button> */}
        <button
  className={`icon-btn refresh-btn ${isSyncing ? "sync-rotating" : ""}`}
  onClick={handleRefreshTransactions}
  disabled={showFundingWarning || isSyncing}
  title={
    showFundingWarning
      ? "Add a funding account to enable refresh"
      : isSyncing
      ? "Syncing transactions..."
      : "Refresh Transactions"
  }
  style={{
    opacity: showFundingWarning || isSyncing ? 0.5 : 1,
    cursor: showFundingWarning || isSyncing ? "not-allowed" : "pointer"
  }}
>
  <FaSyncAlt />
</button>

        <input
  type="file"
  accept=".csv"
  style={{ display: "none" }}
  ref={(ref) => (window.csvInputRef = ref)}
  onChange={handleCSVUpload}
/>
<button
  className="icon-btn upload-btn"
  onClick={() => setShowUploadInstruction(true)}
  title="Upload CSV"
>
  Upload CSV
</button>


      </div>


      {showUploadInstruction && (
  <>
    <div className="overlay-transactions" onClick={() => setShowUploadInstruction(false)}></div>
    <div className="popup-transactions upload-instruction-popup">
      <h4>CSV Upload Instructions</h4>

      <div className="sample-csv-instructions">
  {/* Horizontal left arrow */}
  <div className="arrow-left-msg">→ Change header names to upload</div>

  <div className="sample-table-wrapper">
    {/* Vertical top arrows */}
    <div className="arrow-top-row">
      <div className="arrow-top-msg">↓ Only include this column</div>
      <div className="arrow-top-msg">↓ Only include this column</div>
      <div className="arrow-top-msg">↓ Only include this column</div>
    </div>

    <table className="sample-csv-table">
      <thead>
        <tr>
          <th>Date</th>
          <th>Description</th>
          <th>Amount</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>2025-05-12</td>
          <td>Coffee Shop</td>
          <td>4.50</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>


      <button
        className="save-pop-up"
        onClick={() => {
          setShowUploadInstruction(false);
          setTimeout(() => window.csvInputRef.click(), 200); // Allow popup to close smoothly
        }}
      >
        Upload CSV
      </button>

      <button className="cancel-pop-up" onClick={() => setShowUploadInstruction(false)}>
        Cancel
      </button>
    </div>
  </>
)}





      {showCsvPreview && (
  <>
    <div className="overlay-transactions" onClick={() => setShowCsvPreview(false)}></div>
    <div className="popup-transactions">
      <h4>Preview CSV Transactions</h4>
      <table className="table transactions-table">
        <thead>
          <tr>
            {Object.keys(csvPreviewData[0] || {}).map((key, idx) => (
              <th key={idx}>{key}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {csvPreviewData.slice(0, 10).map((row, i) => (
            <tr key={i}>
              {Object.values(row).map((val, idx) => (
                <td key={idx}>{val}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
      {csvPreviewData.length > 10 && (
  <p style={{ marginTop: "10px", fontStyle: "italic" }}>
    Showing first 10 transactions of {csvPreviewData.length} total. 
  </p>
)}
     <select
  value={selectedUploadAccount}
  onChange={(e) => setSelectedUploadAccount(e.target.value)}
  className="csv-upload-account-select"
>
  <option value="">Select Account</option>
  {accounts.map((acct) => (
    <option key={acct.account_id} value={acct.account_id}>
      {acct.subtype} ••••{acct.mask}
    </option>
  ))}
</select>

      <button
  className="save-pop-up"
  disabled={isCsvSubmitting || !selectedUploadAccount}
  onClick={async () => {
    if (isCsvSubmitting) return; // guard against double-clicks

    // ✅ Validate BEFORE posting
    if (!selectedUploadAccount) {
      alert("Please select an account before uploading.");
      return;
    }
    if (!csvPreviewData.length) {
      alert("There is no data to upload.");
      return;
    }

    setIsCsvSubmitting(true);
    try {
      await api.post(`/transactions/upload/${businessId}`, {
        data: csvPreviewData,
        account_id: selectedUploadAccount,
      });

      alert("CSV uploaded successfully");
      setShowCsvPreview(false);
      fetchTransactions(true); // refresh
    } catch (err) {
      console.error("CSV upload failed", err);
      alert("Upload failed.");
    } finally {
      setIsCsvSubmitting(false);
    }
  }}
>
  {isCsvSubmitting ? "Uploading..." : "Submit"}
</button>

      <button className="cancel-pop-up" onClick={() => setShowCsvPreview(false)}>
        Cancel
      </button>
    </div>
  </>
)}


      {showAddPopup && (
        <>
        <div className="overlay-transactions" onClick={() => setShowAddPopup(false)}></div>
            <div className="popup-transactions" style={{ display: "flex", flexDirection: "column" }}>
              <h4>Add Transaction</h4>
              <input type="date" value={newTxn.date} onChange={(e) => setNewTxn({ ...newTxn, date: e.target.value })} />
              <input type="text" placeholder="Description" value={newTxn.name} onChange={(e) => setNewTxn({ ...newTxn, name: e.target.value })} />
              <select value={newTxn.category} onChange={(e) => setNewTxn({ ...newTxn, category: e.target.value })}>
                <option value="">Select Category</option>
                {categories.map((cat) => (
                  <option key={cat.id} value={cat.name}>{formatCategory(cat.name)}</option>
                ))}
              </select>
              <select value={newTxn.category_type} onChange={(e) => setNewTxn({ ...newTxn, category_type: e.target.value })}>
                <option value="">Type of Transaction</option>
                <option value="expense">Expense</option>
                <option value="income">Income</option>
              </select>
              <select
                  value={newTxn.account_id}
                  onChange={(e) => setNewTxn({ ...newTxn, account_id: e.target.value })}
                >
                  <option value="">Select Account</option>
                  {accounts.map((acct) => (
                    <option key={acct.account_id} value={acct.account_id}>
                      {acct.subtype} ••••{acct.mask}
                    </option>
                  ))}
                </select>


              <input
                type="number"
                placeholder="Amount"
                value={newTxn.amount}
                onChange={(e) =>
                  setNewTxn({ ...newTxn, amount: e.target.value })
                }
                step="0.01"
                inputMode="decimal"
                onWheel={(e) => e.target.blur()}
                onKeyDown={(e) => (e.key === "ArrowUp" || e.key === "ArrowDown") && e.preventDefault()}
              />


              <textarea placeholder="Notes" value={newTxn.notes} onChange={(e) => setNewTxn({ ...newTxn, notes: e.target.value })} />
              <button className="save-pop-up" onClick={handleAddTransaction}>Submit</button>
              <button className="cancel-pop-up" onClick={() => setShowAddPopup(false)}>Cancel</button>
            </div>
            </>
          )}


      {showCategoryPopup && (
          <div className="category-transactions-popup">
            <h3>Add New Category</h3>
            <input
              type="text"
              value={newCategory}
              onChange={(e) => setNewCategory(e.target.value)}
              placeholder="Enter category name"
            />
            <select
              value={categoryType}
              onChange={(e) => setCategoryType(e.target.value)}
            >
              <option value="Expense">Expense</option>
              <option value="Income">Income</option>
            </select>
            <button onClick={handleCategorySubmit}>Submit</button>
            <button onClick={() => setShowCategoryPopup(false)}>Cancel</button>
          </div>
        )}


      {showEditPopup && (
        <>
          <div className="overlay-transactions" onClick={() => setShowEditPopup(false)}></div>
          <div className="popup-transactions" style={{ display: "flex" }}>
            <select
              value={editCategory}
              onChange={(e) => {
                if (e.target.value === "add_new_category") {
                  setShowCategoryPopup(true); // 👈 trigger category creation popup
                } else {
                  setEditCategory(e.target.value);
                }
              }}
              className="form-control"
            >
              <option value="">Select Category</option>
              {categories.map((cat) => (
                <option key={cat.id} value={cat.name}>
                  {formatCategory(cat.name)}
                </option>
              ))}
            </select>
            <button onClick={handleEditSelected} className="cat-smt">
              Submit
            </button>
            <button onClick={() => setShowEditPopup(false)} className="cat-can-smt">
            <MdOutlineCancel />
            </button>
          </div>
        </>
      )}

      

      
  <div ref={tableRef}>
    <table className="transactions-table">
      <thead>
        <tr>
          <th className="text-checkbox">
          <input
        type="checkbox"
        checked={selectAll}
        onChange={handleSelectAll}
      />
          </th>
          <th className="text-date">Date</th>
          <th className="text-description">Description</th>
          <th className="text-category">Category</th>
          <th >Amount</th>
          <th className="text-notes">Notes</th>
          <th className="text-bank">Account</th>
        </tr>
      </thead>
      <tbody>
        {transactions.map((txn) => (
          <tr key={txn.id}
              className={`transaction-rows-mobile ${selectedTransactions.includes(txn.id) ? "selected-row" : ""}`}
              onClick={() => {
                if (window.innerWidth <= 768) handleSelectTransaction(txn.id); // only on small screens
              }}
            >

            {/* <td>
              <input
                type="checkbox"
                checked={selectedTransactions.includes(txn.id)}
                onChange={() => handleSelectTransaction(txn.id)}
              />
            </td> */}
            <td className="text-checkbox">
              <input
                type="checkbox"
                checked={selectedTransactions.includes(txn.id)}
                onChange={() => handleSelectTransaction(txn.id)}
                className="txn-checkbox"
              />
            </td>

            <td className="date-data">
  {new Date(txn.date.substring(0, 10) + "T12:00:00").toLocaleDateString()}
</td>
            <td className="description-data">{txn.name}</td>
            <td className="category-data">{formatCategory(txn.category)}</td>
            <td
              style={{
                color: txn.amount < 0 ? "var(--brand)" : "var(--brand-ghost)",
                fontWeight: "bold", textAlign:'left'
              }}
            >
              {Math.abs(txn.amount).toLocaleString("en-US", {
                style: "currency",
                currency: txn.currency_code || "USD",
              })}
            </td>
            <td className="text-notes">
  <div className="notes-content">
    <span className="note-text">{txn.notes || ""}</span>

    {txn.notes ? (
      <button
        className="icon-btn edit-note-btn"
        onClick={() => {
          setCurrentNote(txn.notes);
          setCurrentTxnId(txn.id);
          setShowNotePopup(true);
        }}
        title="Edit Note"
      >
        <FaEdit />
      </button>
    ) : (
      <button
        className="icon-btn add-note-btn"
        onClick={() => {
          setCurrentNote("");
          setCurrentTxnId(txn.id);
          setShowNotePopup(true);
        }}
        title="Add Note"
      >
        <FaPlus />
      </button>
    )}
  </div>
</td>

            <td className="text-bank">
              {txn.account_name || ""} {txn.mask || ""}
            </td>
          
          </tr>
        ))}
        <tr>
  <td colSpan="7" className="get-more-div">
    {hasMore ? (
      <button
        className="get-more-btn"
        onClick={() => fetchTransactions(false)}
      >
        Get More
      </button>
    ) : (
      <span>No more transactions to show.</span>
    )}
  </td>
</tr>
      </tbody>


      {searchSubmitted && lastSearchedCategory !== "" && lastSearchedCategory !== "all" && (
  <tfoot>
    <tr>
      <td className="text-checkbox"></td>
      <td className="text-date"></td>
      <td className="text-description"></td>
      <td className="text-category"><strong>Total</strong></td>
      <td style={{ fontWeight: "bold", color: totalAmount < 0 ? "var(--brand)" : "var(--brand-ghost)" }}>
        {Math.abs(totalAmount).toLocaleString("en-US", {
          style: "currency",
          currency: "USD",
        })}
      </td>
      <td className="text-notes"></td>
      <td className="text-bank"></td>
    </tr>
  </tfoot>
)}



      


    </table>
    {showNotePopup && (
  <>
    <div className="overlay-transactions" onClick={() => setShowNotePopup(false)}></div>
    <div className="popup-transactions">
      <h4>{currentNote ? "Edit Note" : "Add Note"}</h4>
      <textarea
        value={currentNote}
        onChange={(e) => setCurrentNote(e.target.value)}
        rows="5"
        style={{ width: "100%", marginBottom: "10px" }}
      />
      <button
        onClick={async () => {
          try {
            await api.put(`/api/plaid/transactions/update-note`, {
              id: currentTxnId,
              note: currentNote,
            });
            alert("Note updated!");
            setShowNotePopup(false);
            fetchTransactions(true); // refresh the table
          } catch (err) {
            console.error("Failed to update note", err);
            alert("Failed to update note");
          }
        }}
      >
        Save
      </button>
      <button className="cancel-pop-up" onClick={() => setShowNotePopup(false)}>
      Cancel
      </button>
    </div>
  </>
)}

  </div>



      
    </div>
  );
};

export default TransactionsPage;





